"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsNotEmptyObject = exports.HasOnlyBooleanValues = exports.HasValidValuesBase = exports.HasValidKeysBase = exports.IsPlainObject = exports.isNotUndefined = exports.isNotNull = void 0;
const index_1 = require("./index");
const { ValidatorConstraint } = index_1.Validator;
const isNotNull = ({}, v) => {
    return v !== null;
};
exports.isNotNull = isNotNull;
const isNotUndefined = ({}, v) => {
    return v !== undefined;
};
exports.isNotUndefined = isNotUndefined;
let IsPlainObject = class IsPlainObject {
    validate(subject, _args) {
        return typeof subject === "object" && subject.constructor.name === "Object";
    }
    defaultMessage(_args) {
        return "Value is not a plain Object";
    }
};
IsPlainObject = __decorate([
    ValidatorConstraint({ name: "isPlainObject", async: false })
], IsPlainObject);
exports.IsPlainObject = IsPlainObject;
class HasValidKeysBase {
    constructor() {
        this.invalidKeys = [];
    }
    validate(subject, _args) {
        this.invalidKeys.length = 0;
        if (typeof subject !== "object" || subject.constructor.name !== "Object") {
            return false;
        }
        this.invalidKeys = Object.keys(subject).filter(key => !this.validateKey(key));
        return this.invalidKeys.length === 0;
    }
    invalidKeysMessage() {
        return `Object has invalid keys: "${this.invalidKeys.join(",")}".`;
    }
    defaultMessage(_args) {
        if (this.invalidKeys.length === 0) {
            return "Data is not an object.";
        }
        else {
            return this.invalidKeysMessage();
        }
    }
}
exports.HasValidKeysBase = HasValidKeysBase;
class HasValidValuesBase {
    validate(subject, _args) {
        this.invalidValuesByKey = {};
        if (typeof subject !== "object" || subject.constructor.name !== "Object") {
            return false;
        }
        Object.keys(subject)
            .filter(key => !this.validateValue(subject[key]))
            .forEach(key => {
            this.invalidValuesByKey[key] = subject[key];
        });
        return Object.keys(this.invalidValuesByKey).length === 0;
    }
    invalidValuesMessage() {
        return `Object has invalid values for these keys: "${Object.keys(this.invalidValuesByKey).join(",")}".`;
    }
    defaultMessage(_args) {
        if (Object.keys(this.invalidValuesByKey).length === 0) {
            return "Data is not an object.";
        }
        else {
            return this.invalidValuesMessage();
        }
    }
}
exports.HasValidValuesBase = HasValidValuesBase;
let HasOnlyBooleanValues = class HasOnlyBooleanValues extends HasValidValuesBase {
    validateValue(value) {
        return typeof value === "boolean";
    }
    invalidValuesMessage() {
        return `Values for these keys are not boolean: "${Object.keys(this.invalidValuesByKey).join(",")}".`;
    }
};
HasOnlyBooleanValues = __decorate([
    ValidatorConstraint({ name: "hasOnlyBooleanValues", async: false })
], HasOnlyBooleanValues);
exports.HasOnlyBooleanValues = HasOnlyBooleanValues;
let IsNotEmptyObject = class IsNotEmptyObject {
    validate(value) {
        return (typeof value === "object" &&
            value !== null &&
            !(value instanceof Array) &&
            Object.keys(value).length !== 0);
    }
    defaultMessage() {
        return "Object is empty";
    }
};
IsNotEmptyObject = __decorate([
    ValidatorConstraint({ name: "isNotEmptyObject", async: false })
], IsNotEmptyObject);
exports.IsNotEmptyObject = IsNotEmptyObject;
//# sourceMappingURL=validate.js.map